import {
    call, put, takeEvery, select,
} from 'redux-saga/effects';
import { setLatestLeadMargin, setLeadValuation } from '../../requests/set_lead_valuation_request';
import { resetPartEx } from '../../requests/reset_part_ex_request';
import { SET_LEAD_VALUATION_REQUEST } from '../../../Manage_retail/redux/constants/assign_lead.constants';
import { GET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA } from '../../../LeadPaymentApproval/constants';
import { getLeadsAllValuations } from '../../requests/get_leads_valuations_request';
import { getLeadsAllValuationsRequestFailure } from '../actions/get_leads_all_valuations.actions';
import { message_success, message_warn, message_error } from '../../../../../components/Message';
import { each, get } from '../../../../../shared/helpers';
import { SET_LEAD_VALUATIONS_REDUCER } from '../constants/get_lead_profile.constants';
import { changeLeadsStatusRequestSuccess } from '../actions/change_lead_status.actions';
import { assignLeadSuccess } from '../../../Manage_retail/redux/actions/assign_lead.actions';
import { assignLead } from '../../../Manage_retail/requests/assign_lead_request';
import { getLeadAgent, getLeadProfileWithApprovals } from '../../requests/get_lead_profile_request';


function* setLeadValuationRequest({
    _id, valuation, description, suggested_margin, retail_price, selected_reference_bike, auto_reference_bike, auto_reference_bike_price, auto_retail_price, auto_wwym_price, kipper_bike, kipper_reason, is_trade,
}) {
    yield call(setLatestLeadMargin, _id, suggested_margin);
    const { result, options, error } = yield call(setLeadValuation, _id, valuation, description, suggested_margin, retail_price, selected_reference_bike, auto_reference_bike, auto_reference_bike_price, auto_retail_price, auto_wwym_price, kipper_bike, kipper_reason, is_trade);
    const store = yield select();
    yield call(resetPartEx, _id);

    if (result) {
        const approvals = yield call(getLeadProfileWithApprovals, _id);
        if (approvals.result) {
            yield put({ type: 'CHECK_APPROVAL', payload: approvals.options.approval });
        }
        const { clean } = store.Leads.Lead_profile.Lead_cap_valuation.cap_valuation;
        if (clean && (clean <= options.valuations.pop().valuation)) {
            message_warn(`The CAP clean price for this bike is £${clean}, your valuation could be too high.`);
        }
        const valuations = yield call(getLeadsAllValuations, options.ref_bike_lead);
        if (valuations.result) {
            valuations.options.forEach(option => option.valuations.map(valuation => Object.assign(valuation, { division: option.ref_lead_source.abbr })));
            yield put({ type: SET_LEAD_VALUATIONS_REDUCER, payload: valuations.options[0].valuations });
            yield put(changeLeadsStatusRequestSuccess(valuations.options[0]));
            yield call(assignLead, store.App.App_content.user._id, store.Leads.Lead_profile.Lead_general.root_id);
            const agent = yield call(getLeadAgent, store.Leads.Lead_profile.Lead_general.root_id);
            yield put(assignLeadSuccess(agent.options.ref_assigned_to));

            const blemQ2 = store.Leads.Lead_profile.Lead_blemish_report.blemish_report?.questions?.question_2;
            const customerData = store.Leads.Lead_profile.Ref_lead_customer.customer_details;
            
            yield put({
                type: GET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA,
                leadId: _id,
                valuationsFromProfile: [...valuations.options[0].valuations],
                blemQ2,
                leadCustomer: customerData
            });
        } else {
            yield put(getLeadsAllValuationsRequestFailure(valuations.error));
            message_success('New Price Added Successfully!');
        }
    } else {
        let alreadyExistError = '';
        if (error instanceof Object) {
            each(error.errors, (key, value) => {
                alreadyExistError += get(value, 'reason.message') || get(value, 'reason');
            });
            yield put(getLeadsAllValuationsRequestFailure(error));
            message_error(alreadyExistError);
        } else {
            yield put(getLeadsAllValuationsRequestFailure(error));
            message_error(error);
        }
    }
}

export default function* setLeadValuationSaga() {
    yield takeEvery(SET_LEAD_VALUATION_REQUEST, setLeadValuationRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/set_lead_valuation.saga.js